React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')()

module.exports = class CanonicalDetailOverflowMenu extends React.Component
  displayName: 'CanonicalDetailOverflowMenu'

  render: t.renderable ->
    { menuItems } = @props

    if menuItems?.length > 0
      t.ul '.pop-over-list', ->
        menuItems.forEach(({ name, onClick }, index) =>
          t.li { key: index }, ->
            t.a { onClick }, ->
              t.text name
        )
